import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from 'app/shared';
import {
  CreateSegmentRequest,
  CreateSegmentFromUsersRequest,
  DeleteSegmentRequest,
  DeleteSegmentResponse,
  SegmentLogic,
  SegmentResponse,
  UpdateSegmentRequest,
  ValidateEmailsResponse,
  ValidateEmailsRequest,
  UpdateSegmentUsersRequest, UpdateSegmentUsersResponse
} from '../models/segment.model';

@Injectable({
    providedIn: 'root'
})
export class SegmentService {
    private _http = inject(HttpClient);
    private _config = inject(ConfigurationService);


    getLogic(): Observable<SegmentLogic> {
      return this._http.get<SegmentLogic>(`${this._config.apiUrl}/api/segment/logic`);
    }

    getSegment(id: number): Observable<SegmentResponse> {
      return this._http.get<SegmentResponse>(`${this._config.apiUrl}/api/segment/${id}`);
    }

    createSegment(model: CreateSegmentRequest): Observable<SegmentResponse> {
      return this._http.post<SegmentResponse>(`${this._config.apiUrl}/api/segment`, model);
    }

    createSegmentFromUsers(model: CreateSegmentFromUsersRequest): Observable<SegmentResponse> {
      return this._http.post<SegmentResponse>(`${this._config.apiUrl}/api/segment/manual`, model);
    }

    updateSegment(model: UpdateSegmentRequest): Observable<SegmentResponse> {
      return this._http.put<SegmentResponse>(`${this._config.apiUrl}/api/segment/${model.id}`, model);
    }

    updateSegmentFromUsers(model: UpdateSegmentRequest): Observable<SegmentResponse> {
      return this._http.put<SegmentResponse>(`${this._config.apiUrl}/api/segment/manual`, model);
    }

    updateUsersInSegmentFromUsers(model: UpdateSegmentUsersRequest): Observable<UpdateSegmentUsersResponse> {
      return this._http.put<UpdateSegmentUsersResponse>(`${this._config.apiUrl}/api/segment/manual/users`, model);
    }

    deleteSegment(model: DeleteSegmentRequest): Observable<DeleteSegmentResponse> {
      return this._http.delete<DeleteSegmentResponse>(`${this._config.apiUrl}/api/segment/${model.id}`);
    }

    validateEmails(model: ValidateEmailsRequest): Observable<ValidateEmailsResponse> {
      return this._http.post<ValidateEmailsResponse>(`${this._config.apiUrl}/api/segment/validateemails`, model);
    }
}
